module.exports = __webpack_public_path__ + "img/kehren.7db988cf.svg";